import React from 'react';

interface UserAvatarProps {
    name: string;
    avatarUrl?: string;
    className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ name, avatarUrl, className = "w-8 h-8" }) => {
    // Determine initials
    const getInitials = (fullName: string) => {
        const parts = fullName.split(' ').filter(p => p.length > 0);
        if (parts.length === 0) return 'U';
        if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
        return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
    };

    const initials = getInitials(name || 'User');

    return (
        <div className={`relative inline-flex items-center justify-center overflow-hidden bg-blue-600 rounded-full shadow-sm border border-white/20 ${className}`}>
            {avatarUrl ? (
                <img 
                    src={avatarUrl} 
                    alt={name} 
                    className="w-full h-full object-cover"
                    onError={(e) => {
                        // Fallback if image fails to load
                        e.currentTarget.style.display = 'none';
                        const parent = e.currentTarget.parentElement;
                        if (parent && !parent.querySelector('.avatar-fallback')) {
                            const fallback = document.createElement('span');
                            fallback.className = 'avatar-fallback font-semibold text-white tracking-wider text-xs';
                            fallback.textContent = initials;
                            parent.appendChild(fallback);
                        }
                    }}
                />
            ) : (
                <span className="font-semibold text-white tracking-wider text-xs">
                    {initials}
                </span>
            )}
        </div>
    );
};

export default UserAvatar;
